export default defineNuxtRouteMiddleware((to) => {
  if (!process.client) return
  const browser = useBrowser()
  if (to.fullPath.includes('/advertise') && browser.value !== 'SHIFT') {
    return clearError({
      redirect: '/partnerships',
    })
  }
})
